import React from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import { Jumbotron, Button, Row, FormControl, Col, ControlLabel, InputGroup } from 'react-bootstrap';
import Switcher from 'react-switcher';
import Geosuggest from 'react-geosuggest';
import ScrollableAnchor from 'react-scrollable-anchor';
import { Column, Table, List  } from 'react-virtualized';
import _ from 'lodash';

import CitiesComponent from './CitiesComponent';
import CountriesComponent from './CountriesComponent';
import { gettext } from '../../../i18n/service.js';
import DeleteConfirmation from '../../modals/DeletePickupPointModal';
import DeleteModal from '../../modals/DeleteModal.js';
import formatCamelCase from '../../../businessLogic/formatCamelCase.js';
import LoopbackHttp from '../../../businessLogic/LoopbackHttp.js';
import * as Validation from '../../../businessLogic/fieldValidation.js';
import MapModalComponent from '../../../components/MapModalComponent';
import * as settingsActions from '../../../actions/settingsActions';
import * as appActions from '../../../actions/appActions';

class TeamsComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.selectedTeam = undefined;
    this.selectedUserForAssign = undefined;
    this.selectedUserForUnAssign = undefined;
    this.isShowingMap = false;
    this.isShowingPolygonMap = false;
    this.isShowingHubMap = false;

    this.newPickupPoint = {};
    this.selectedPickupPoint = {};

    this.createTeam = false;
    this.editTeam = false;
    this.selectedCountry = undefined;

    this.teamFilters = {
      members: undefined,
      notMembers: undefined,
      userTeamsFilter: undefined
    };

    this.geocoder = new window.google.maps.Geocoder();

    _.bindAll(this, ['getSelectedTeam', 'flipEditTeam', 'renderTeamEditForm', 'renderTeamLists', 'flipCreateTeam', 'deleteTeam', 'resetBools',
                      'resetState', 'updateTeam', 'validateTeamFields', 'createNewTeam', 'renderPickUpPoints', 'renderEditPickUpPoints',
                      'addToTeam', 'getUserForAssign', 'getUserForUnAssign', 'getTeamLength', 'onMapClick', 'showMapEdit',
                      'hideMapEdit', 'renderNewPickupPoint', 'cancelNewPoint', 'deletePoint', 'renderActivateButtons', 'renderEnableHub', 'activateDeactivateAutoassign',
                      'hidePolygonMapEdit', 'showPolygonMapEdit', 'removePolygon', 'setPolygon', 'setCity', 'enableHub',
                      'onHubMapClick', 'showHubMap', 'renderUserMembersView', 'hideHubMap', 'clearCity', 'deleteCallback', 'setCountry']);

    this.state = {
      name: undefined,
      countryId: undefined,
      cityId: undefined,
      filterValue: undefined,
      polygon: undefined,
      default: true,
      hubGeoPoint: {lat: undefined, lng:undefined},
      hubRadius: undefined
    };

    this.baseState = this.state;
  }

  componentDidMount() {
    this.props.appActions.startSpinner();
    if (LoopbackHttp.isFleet) {
      this.props.settingsActions.getAllFleetOperators(this.props.company.id);
      this.props.settingsActions.getAllFleetDispatchers(this.props.company.id);
      this.props.settingsActions.getAllFleetDrivers(this.props.company.id);
      this.props.settingsActions.getAllFleetPlatforms(this.props.company.id);

      this.props.settingsActions.getTeamsForFleetSettings(this.props.company.id);
    }
    else if(LoopbackHttp.isOperator) {
      this.props.settingsActions.getTeamsForOperatorSettings(this.props.account.id);
      this.props.settingsActions.getAllOperatorUsers(this.props.account.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.createdPickUpPoint !== this.props.createdPickUpPoint) {
      this.props.pickUpPoints.push(nextProps.createdPickUpPoint);
      this.props.endSpinner();
    }

    if(nextProps.teams !== this.props.teams) {
      this.props.appActions.endSpinner();
    }

    if (nextProps.addedToTeam !== this.props.addedToTeam
      || nextProps.removedFromTeam !== this.props.removedFromTeam) {
      this.props.appActions.startSpinner();
      this.props.settingsActions.getTeam(this.selectedTeam.id);
      this.props.appActions.endSpinner();
    }

    if(nextProps.teams !== this.props.teams && this.selectedTeam) {
      this.props.fetchCityForInfo(this.selectedTeam.cityId);
      this.setState({default:this.selectedTeam.default});
      this.setState(this.selectedTeam);
    }
  }

  clearCity(){
    this.setState({cityId: undefined});
  }

  setPolygon(polygon) {
    this.setState({polygon});
  }

  renderActivateButtons() {
    return (
      <div className="switcher">
        <Switcher
          on={this.selectedTeam.autoAssign}
          onClick={() => this.activateDeactivateAutoassign()}/>
      </div>
    );
  }
  renderEnableHub(){
    return (
      <div className="switcher">
        <Switcher
          on={this.selectedTeam.hubStatus}
          onClick={() => this.enableHub()}/>
      </div>
    );
  }

  activateDeactivateAutoassign() {
    this.props.startSpinner();
    this.props.updateTeam(this.selectedTeam.id, {autoAssign: !this.selectedTeam.autoAssign});
  }
  enableHub() {

  }
  deletePoint(point) {
    _.pull(this.props.pickUpPoints, point);
    this.forceUpdate();
  }

  onMapClick({latLng}) {
    const location = {
      lat: latLng.lat(),
      lng: latLng.lng()
    };

    this.geocoder.geocode({location: location}, (results) => {
      if(this.newPickupPoint.toCreate) {
        this.newPickupPoint.gpsLocation = location;
        this.newPickupPoint.address = results[0].formatted_address;
      }

      if(this.selectedPickupPoint.id) {
        this.selectedPickupPoint.gpsLocation = location;
        this.selectedPickupPoint.address = results[0].formatted_address;
      }
      this.hideMapEdit();
    });
  }

  onHubMapClick({latLng}) {
    const location = {
      lat: latLng.lat(),
      lng: latLng.lng()
    };

    this.geocoder.geocode({location: location}, (results) => {
      this.setState({hubGeoPoint: location, hubAddress: results[0].formatted_address});
      this.hideHubMap();
    });
  }

  showMapEdit() {
    this.isShowingMap = true;
    this.forceUpdate();
  }

  showHubMap() {
    this.isShowingHubMap = true;
    this.forceUpdate();
  }

  showPolygonMapEdit() {
    this.isShowingPolygonMap = true;
    this.forceUpdate();
  }

  hideMapEdit() {
    this.isShowingMap = false;
    this.forceUpdate();
  }

  hideHubMap() {
    this.isShowingHubMap = false;
    this.forceUpdate();
  }

  hidePolygonMapEdit() {
    this.isShowingPolygonMap = false;
    this.forceUpdate();
  }

  cancelNewPoint() {
    this.newPickupPoint = {};
    this.forceUpdate();
  }

  getSelectedTeam(id) {
    this.setState({polygon: undefined}, () => {
      this.props.appActions.startSpinner();
      this.props.settingsActions.getTeam(id);
      this.props.settingsActions.getTeamPoints(id);
      this.resetBools();
      this.selectedTeam = _.find(this.props.teams, { 'id': id });
    })
  }

  removePolygon() {
    let newState = this.state;
    delete newState.polygon;
    this.setState(newState);
  }

  setCity(city) {
    this.setState({cityId: city.id});
  }

  setCountry(country) {
    this.setState({ countryId: country.id });
    this.props.settingsActions.fetchCitiesByCountryId(country.id);
  }

  getUserForAssign(id) {
    let { allDrivers, allOperators, allDispatchers, allDispatcherPlatforms } = this.props;
    let users = allDrivers.concat(allOperators, allDispatchers, allDispatcherPlatforms);
    this.selectedUserForAssign = _.find(users, { 'id': id });
  }

  getUserForUnAssign(id) {
    let { drivers, operators, dispatchers, dispatcherPlatforms } = this.props;
    let users = drivers.concat(operators, dispatchers, dispatcherPlatforms);
    this.selectedUserForUnAssign = _.find(users, { 'id': id });
    this.setState({});
  }

  getTeamLength() {
    let userCount = 0;

    _.map(this.props.users, (user) => {
      if(user.teamId === this.selectedTeam.id)
        userCount++;
    });

    return userCount;
  }

  flipCreateTeam() {
    this.createTeam = !this.createTeam;
    this.resetState();
  }

  flipEditTeam() {
    this.resetBools();
    this.editTeam = !this.editTeam;
    this.forceUpdate();
    if(this.editTeam && this.selectedTeam)
      this.props.settingsActions.fetchCitiesByCountryId(this.selectedTeam.countryId);
  }

  addToTeam() {
    this.props.startSpinner();
    this.props.addToTeam(this.selectedTeam.id, this.selectedUserForAssign.role, this.selectedUserForAssign.id);
    // this.props.settingsActions.getTeam(this.selectedTeam.id);
  }

  removeFromTeam() {
    this.props.startSpinner();
    this.props.removeFromTeam(this.selectedTeam.id, this.selectedUserForUnAssign.role, this.selectedUserForUnAssign.id);
  }

  createNewTeam() {
    if(!this.validateTeamFields())
      return false;
    else {
      delete this.state.filterValue;
      this.props.startSpinner();
      this.props.createTeam(this.props.company.id, this.state);
      this.resetBools();
      this.resetState();
    }
  }

  updateTeam() {
    if(!this.validateTeamFields())
      return false;
    else {
      delete this.state.filterValue;
      this.props.startSpinner();
      this.props.updateTeam(this.selectedTeam.id, this.state);
      let teamId = this.state.id;
      this.props.fetchCityForInfo(this.state.cityId);
      this.resetBools();
      this.resetState();
      // this.getSelectedTeam(teamId);
    }
  }

  deleteTeam() {
    // if(this.getTeamLength() > 0)
    //   return this.props.showMessage({
    //     message: gettext('TEAM-HAVE-USERS'),
    //     level: 'error'
    //   });
    // // this.props.startSpinner();
    // // this.props.deleteTeam(this.selectedTeam.id);
    // // this.resetBools();
    // // this.resetState();
    // this.showDeleteModal = true;
    // this.forceUpdate();
  }

  validateTeamFields() {
    return Validation.nameValidation(this.state.name, this.props.showMessage)
            && Validation.countryValdation(this.state.countryId, this.props.showMessage)
            && Validation.cityValdation(this.state.cityId, this.props.showMessage);
            // && Validation.polygonValdation(this.state.polygon, this.props.showMessage)
            // && Validation.hubValidation(this.state.hubGeoPoint, this.props.showMessage)
            // && Validation.hubRadiusValidation(this.state.hubRadius, this.props.showMessage);

  }

  resetState() {
    this.selectedTeam = undefined;
    for ( var prop in this.state ) {
      delete this.state[prop];
    }
    this.setState(this.baseState);
  }

  resetBools() {
    this.createTeam = false;
    this.editTeam = false;
  }

  renderTeamForm() {
    return (
      <div className="dispatcher_profile">
        <ScrollableAnchor id={'teams_anchor'}>
          <div />
        </ScrollableAnchor>
        <Jumbotron className="position_relative">
          <div className="text_align_center margin_bottom_em">
            <h3>{gettext('TEAM-INFO')}</h3>
          </div>
          <Row>
            <div className="user_data center_div">
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('NAME')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label><h4>{this.selectedTeam.name}</h4></label>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('COUNTRY')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label><h4>{this.props.getCountryByCityId(this.selectedTeam.countryId)}</h4></label>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('CITY')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label><h4>{this.props.getCityById(this.props.cityForInfo)}</h4></label>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('AUTO-ASSIGN')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  {this.renderActivateButtons()}
                </Col>
              </Row>
              {/*
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('HUB-ENABLE')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  {this.renderEnableHub()}
                </Col>
              </Row> */}
              {this.selectedTeam.hubGeoPoint ?
              <div>
                <Row>
                  <Col sm={4}>
                    <ControlLabel><h4>{gettext('HUB-ADDRESS')}</h4></ControlLabel>
                  </Col>
                  <Col sm={6}>
                    <label><h4>{this.selectedTeam.hubAddress}</h4></label>
                  </Col>
                </Row>
              </div> : '' }
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('HUB-RADIUS')}</h4></ControlLabel>
                </Col>
                <Col sm={6}>
                  <label><h4>{this.selectedTeam.hubRadius}</h4></label>
                </Col>
              </Row>
            </div>
            <div className="botom_line" />
            {this.renderUserMembersView()}
            <div className="botom_line" />
            { this.renderPickUpPoints()}
          </Row>
          <div className="edit_link">
            <a onClick={() => this.flipEditTeam()}><h4>{gettext('EDIT')}</h4></a>
          </div>
        </Jumbotron>
      </div>
    );
  }

  renderTeamEditForm() {
    return (
      <div className="dispatcher_profile">
        <ScrollableAnchor id={'teams_anchor'}>
          <div />
        </ScrollableAnchor>
        <Jumbotron className="position_relative">
          <div className="text_align_center margin_bottom_em">
            <h3>{gettext('EDIT-TEAM')}</h3>
          </div>
          <Row>
            <div className="user_data center_div">
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('NAME')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <FormControl
                     type="text"
                     required={true}
                     defaultValue={this.selectedTeam.name}
                     onChange={(e) => this.setState({name: e.target.value})}
                     placeholder={gettext('NAME')}/>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('COUNTRY')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <CountriesComponent
                    countries={this.props.countries}
                    onSelect={this.setCountry}
                    clearCity={this.clearCity}
                    defaultValue={this.props.getCountryById(this.selectedTeam.countryId)} />
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('CITY')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <CitiesComponent
                    cities={this.props.cities}
                    onSelect={this.setCity}
                    clearCity={this.clearCity}
                    defaultValue={this.props.getCityById(this.props.cityForInfo)} />
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('ZONE')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <Button onClick={() => {this.showPolygonMapEdit();}}>{gettext('SELECT-TEAM-ZONE')}</Button>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('DEFAULTTEAM')}</h4></ControlLabel>
                </Col>
                <Col sm={8} className="setAsDefault">
                  <input type="checkbox"
                    checked={this.state.default}
                    onChange={() => {this.setState({default: !this.state.default});}}/>
                  {gettext('SET-TEAM-AS-DEFAULT')}
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('HUB-ADDRESS')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <InputGroup>
                    <FormControl
                       type="text"
                       required={true}
                       disabled
                       value={this.state.hubAddress}
                       name="deliveryPoint"
                       className="_recipient_ _order_ form-control"
                       placeholder={gettext('HUB-ADDRESS')}/>
                    <InputGroup.Addon onClick={() => this.showHubMap()}>
                      {gettext('SELECT-ON-MAP')}
                    </InputGroup.Addon>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('HUB-RADIUS')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <FormControl
                     type="text"
                     required={true}
                     defaultValue={this.selectedTeam.hubRadius}
                     onChange={(e) => this.setState({hubRadius: e.target.value})}
                     placeholder={gettext('HUB-RADIUS')}/>
                </Col>
              </Row>
            </div>
            <div className="botom_line" />
            {this.renderTeamLists()}
            <div className="botom_line" />
            <div className="text_align_center margin_bottom_em">
              <h3>{gettext('PICK-UP-POINTS')}</h3>
            </div>
            {this.renderEditPickUpPoints()}
          </Row>
        </Jumbotron>
      </div>
    );
  }

  renderTeamCreateForm() {
    return (
      <div className="dispatcher_profile">
        <ScrollableAnchor id={'teams_anchor'}>
          <div />
        </ScrollableAnchor>
        <Jumbotron className="position_relative">
          <div className="text_align_center margin_bottom_em">
            <h3>{gettext('NEW-TEAM')}</h3>
          </div>
          <Row>
            <div className="user_data center_div">
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('NAME')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <FormControl
                     type="text"
                     required={true}
                     onChange={(e) => this.setState({name: e.target.value})}
                     placeholder={gettext('NAME')}/>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('COUNTRY')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <CountriesComponent
                    countries={this.props.countries}
                    onSelect={this.setCountry}
                    clearCity={this.clearCity} />
                  {/* <FormControl
                    componentClass="select"
                    className="_order_"
                    placeholder="select"
                    onChange={(e) => {
                      this.setState({countryId: e.target.value});
                      this.props.settingsActions.fetchCitiesByCountryId(e.target.value);
                    }}
                    name="country">
                      <option disabled selected value={undefined}>{gettext('SELECT-COUNTRY')}</option>
                      { this.props.getCountries() }
                  </FormControl> */}
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('CITY')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <CitiesComponent
                  cities={this.props.cities}
                  onSelect={this.setCity}
                  clearCity={this.clearCity} />
                </Col>
              </Row>
              {/*
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('ZONE')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <Button onClick={() => {this.showPolygonMapEdit()}}>{gettext('SELECT-TEAM-ZONE')}</Button>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('HUB-ADDRESS')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <InputGroup>
                    <FormControl
                       type="text"
                       required={true}
                       disabled
                       value={this.state.hubAddress}
                       name="deliveryPoint"
                       className="_recipient_ _order_ form-control"
                       placeholder={gettext('HUB-ADDRESS')}/>
                    <InputGroup.Addon onClick={() => this.showHubMap()}>
                      {gettext('SELECT-ON-MAP')}
                    </InputGroup.Addon>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('HUB-RADIUS')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <FormControl
                     type="text"
                     required={true}
                     onChange={(e) => this.setState({hubRadius: e.target.value})}
                     placeholder={gettext('HUB-RADIUS')}/>
                </Col>
              </Row>
              */}
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('DEFAULTTEAM')}</h4></ControlLabel>
                </Col>
                <Col sm={8} className="setAsDefault">
                  <input type="checkbox"
                    checked={this.state.default}
                    onChange={() => this.setState({default: !this.state.default})}/>
                  {gettext('SET-TEAM-AS-DEFAULT')}
                </Col>

              </Row>
            </div>
          </Row>
          <div className="actions">
            <Button bsStyle="primary" onClick={() => this.createNewTeam()}>{gettext('SAVE')}</Button>
            <Button bsStyle="danger" onClick={() => {this.resetState(); this.flipEditTeam();}}>{gettext('CANCEL')}</Button>
          </div>
        </Jumbotron>
      </div>
    );
  }

  usersRowRenderer ({
      key,         // Unique key within array of rows
      index,       // Index of row within collection
      isScrolling, // The List is currently being scrolled
      isVisible,   // This row is visible within the List (eg it is not an overscanned row)
      style        // Style object to be applied to row (to position it)
    }, users, teamMembers) {
      let className = '';
      if(teamMembers) {
        if(this.selectedUserForUnAssign && this.selectedUserForUnAssign.id === users[index].id)
          className = 'active';
      } else {
        if(this.selectedUserForAssign && this.selectedUserForAssign.id === users[index].id)
          className = 'active';
      }
      return (
        <div
          key={key}
          style={style}
          className={className}
          onClick={() => {
            teamMembers
              ? this.getUserForUnAssign(users[index].id)
              : this.getUserForAssign(users[index].id);
          }} >
          {formatCamelCase(users[index].role)} {users[index].firstName}
        </div>
      );
    }

  renderTeamLists() {
    let { drivers, operators, dispatchers, dispatcherPlatforms,
      allDrivers, allOperators, allDispatchers, allDispatcherPlatforms } = this.props;
    let users = drivers.concat(operators, dispatchers, dispatcherPlatforms);
    let allAccountUsers = allDrivers.concat(allOperators, allDispatchers, allDispatcherPlatforms);

    let teamUsers = _.filter(users, (user) => {
      return user.teamId === this.selectedTeam.id;
    });

    if(this.teamFilters.members)
      teamUsers = _.filter(users, (user) => {
        return ( user.firstName &&
            (user.firstName.toUpperCase().indexOf(this.teamFilters.members.toUpperCase()) != -1
            || user.role.toUpperCase().indexOf(this.teamFilters.members.toUpperCase()) != -1 ));
      });

    let usersToAdd = _.filter(allAccountUsers, (user) => {
      let isUserInTeam = _.find(teamUsers, {id: user.id});
      return !isUserInTeam;
    });

    if(this.teamFilters.notMembers)
      usersToAdd = _.filter(allAccountUsers, (user) => {
        return ( user.firstName &&
            (user.firstName.toUpperCase().indexOf(this.teamFilters.notMembers.toUpperCase()) != -1
            || user.role.toUpperCase().indexOf(this.teamFilters.notMembers.toUpperCase()) != -1 )) ;
      });

    return (
      <div className="user_data center_div">
        <Row>
          <Col sm={5}>
            <ControlLabel><h4>{gettext('TEAM-MEMBERS')}: {teamUsers.length}</h4></ControlLabel>
            <FormControl
               type="text"
               placeholder={gettext('SEARCH')}
               onChange={(e) => {
                 this.teamFilters.members = e.target.value;
                 this.forceUpdate();
               }}/>
            <div className="team_user_select">
              <List
                width={300}
                height={200}
                rowCount={teamUsers.length}
                rowHeight={20}
                rowRenderer={(e) => this.usersRowRenderer(e, teamUsers, true)}
              />
            </div>
          </Col>
          <Col sm={2}>
          { this.editTeam?
            <div className="teamlist_controls">
              <div className="teamlist_button_container">
                <Button bsStyle="primary"
                  onClick={() => this.removeFromTeam()} />
              </div>
              <div className="teamlist_button_container">
                <Button bsStyle="primary"
                  onClick={() => this.addToTeam()} />
              </div>
            </div> : ''
          }
          </Col>
          <Col sm={5}>
            <ControlLabel><h4>{gettext('ALL-USERS')}</h4></ControlLabel>
            <FormControl
               type="text"
               placeholder={gettext('SEARCH')}
               onChange={(e) => {
                 this.teamFilters.notMembers = e.target.value;
                 this.forceUpdate();
               }}/>
            <div className="team_user_select">
              <List
                  width={300}
                  height={200}
                  rowCount={usersToAdd.length}
                  rowHeight={20}
                  rowRenderer={(e) => this.usersRowRenderer(e, usersToAdd)}
                  />
            </div>
          </Col>
        </Row>
        { this.editTeam?
          <div className="actions">
            <Button bsStyle="primary" onClick={() => this.updateTeam()}>{gettext('SAVE')}</Button>
            <Button bsStyle="danger" onClick={() => {this.resetState(); this.flipEditTeam();}}>{gettext('CANCEL')}</Button>
          </div> : ''
        }
      </div>
    );
  }

  renderUserMembersView(){
    let { drivers, operators, dispatchers, dispatcherPlatforms } = this.props;
    let users = drivers.concat(operators, dispatchers, dispatcherPlatforms);

    if(this.teamFilters.teamsUsersViewFilter)
      users = _.filter(users, (user) => {
            return ( user.firstName &&
              user.firstName.toUpperCase().indexOf(this.teamFilters.teamsUsersViewFilter.toUpperCase()) != -1);
        });

    return (
        <div className="user_data center_div">
            <div className="text_align_center margin_bottom_em">
              <h3>{gettext('TEAM-MEMBERS')}</h3>
            </div>
            <Row>
                <Col sm={12}>
                    <FormControl
                        type="text"
                        style={{marginBottom: '1em'}}
                        placeholder={gettext('SEARCH')}
                        onChange={(e) => {
                           this.teamFilters.teamsUsersViewFilter = e.target.value;
                           this.forceUpdate();
                        }}/>
                    <div className="table_container">
                        <Table
                            width={300}
                            height={200}
                            headerHeight={20}
                            rowHeight={30}
                            rowCount={users.length}
                            rowGetter={({ index }) => users[index]}>
                            <Column
                              label="Name"
                              dataKey="firstName"
                              width={500}
                              />
                        </Table>
                    </div>
                </Col>
            </Row>
        </div>
    );
  }

  renderPickUpPoints() {
    if(this.props.pickUpPoints.length > 0)
    return (
      <div>
        <div className="text_align_center margin_bottom_em">
          <h3>{gettext('PICK-UP-POINTS')}</h3>
        </div>
        { _.map(this.props.pickUpPoints, (point, i) => {
            if(point.valid!=false)
            return (
              <div className="user_data center_div"  key={point.id}>
                <Row>
                  <Col sm={4}>
                    <ControlLabel><h4>{gettext('TITLE')}</h4></ControlLabel>
                  </Col>
                  <Col sm={6}>
                    <label><h4>{point.title}</h4></label>
                  </Col>
                </Row>
                <Row>
                  <Col sm={4}>
                    <ControlLabel><h4>{gettext('CONTACT-NAME')}</h4></ControlLabel>
                  </Col>
                  <Col sm={6}>
                    <label><h4>{point.contactName}</h4></label>
                  </Col>
                </Row>
                <Row>
                  <Col sm={4}>
                    <ControlLabel><h4>{gettext('PHONE')}</h4></ControlLabel>
                  </Col>
                  <Col sm={6}>
                    <label><h4>{point.phone}</h4></label>
                  </Col>
                </Row>
                <Row>
                  <Col sm={4}>
                    <ControlLabel><h4>{gettext('ADDRESS')}</h4></ControlLabel>
                  </Col>
                  <Col sm={6}>
                    <label><h4>{point.address}</h4></label>
                  </Col>
                </Row>
                {
                  i !== (this.props.pickUpPoints.length-1) ?
                    <div className="botom_line" /> : ''
                }
              </div>
            );
        })
      }
      </div>
    );
    else
      return (<div className="user_data center_div">{gettext('NO-POINTS')}</div>);
  }

  renderEditPickUpPoints() {
    return (
      <div>
        { _.map(this.props.pickUpPoints, (point, i) => {
            if(point.valid!=false)
            return (
            <div className="user_data center_div" key={point.id}>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('TITLE')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <FormControl
                     type="text"
                     required={true}
                     defaultValue={point.title}
                     className="geosuggest pickup_title"
                     disabled={this.selectedPickupPoint.id !== point.id}
                     onChange={(e) => this.selectedPickupPoint.title = e.target.value}
                     placeholder={gettext('TITLE')}/>
                  <div style={{display: 'inline'}}>
                    <Button
                        bsStyle="primary edit_btn"
                        onClick={() => {
                          this.selectedPickupPoint = point;
                          this.forceUpdate();
                        }} />
                  </div>
                  <DeleteConfirmation
                    ppoint={point}
                    deletePickUpPoint={this.props.settingsActions.editPickUpPoint}/>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('CONTACT-NAME')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <FormControl
                     type="text"
                     required={true}
                     defaultValue={point.contactName}
                     disabled={this.selectedPickupPoint.id !== point.id}
                     onChange={(e) => this.selectedPickupPoint.contactName = e.target.value}
                     placeholder={gettext('CONTACT-NAME')}/>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('PHONE')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <FormControl
                     type="text"
                     required={true}
                     defaultValue={point.phone}
                     disabled={this.selectedPickupPoint.id !== point.id}
                     onChange={(e) => this.selectedPickupPoint.phone = e.target.value}
                     placeholder={gettext('PHONE')}/>
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <ControlLabel><h4>{gettext('ADDRESS')}</h4></ControlLabel>
                </Col>
                <Col sm={8}>
                  <InputGroup>
                    <Geosuggest
                      required={true}
                      name="defaultPickUpPoint"
                      placeholder={gettext('ADDRESS')}
                      inputClassName="_recipient_ _order_ form-control"
                      initialValue={point.address}
                      disabled={this.selectedPickupPoint.id !== point.id}
                      onSuggestSelect={(opts) => {
                           this.selectedPickupPoint.gpsLocation = opts.location;
                           this.selectedPickupPoint.address = opts.label;
                      }}/>

                      <InputGroup.Addon onKeyDown={(e) => props.onKeyDown(e)}
                        disabled={this.selectedPickupPoint.id !== point.id}
                        onClick={() => this.showMapEdit()}>
                        { gettext('SELECT-ON-MAP') }
                      </InputGroup.Addon>
                    </InputGroup>
                </Col>
              </Row>
              {
                this.selectedPickupPoint.id === point.id?
                    <Row>
                      <Col sm={12} className="right_content">
                        <Button className="margin_left_right"
                          bsStyle="primary"
                          onClick={() => {
                            if(!Validation.pickupPointValidation(this.selectedPickupPoint, this.props.showMessage))
                              return false;
                            else {
                              this.props.startSpinner();
                              this.props.updatePickUpPoint(this.selectedPickupPoint);
                              this.selectedPickupPoint = {};
                              this.forceUpdate();
                            }
                          }}>
                            {gettext('UPDATE')}
                        </Button>
                        <Button className="margin_left_right"
                          bsStyle="default"
                          onClick={() => {
                            this.selectedPickupPoint = {};
                            this.forceUpdate();
                          }}>
                            {gettext('CANCEL')}
                        </Button>
                      </Col>
                    </Row> : ''
              }
              <div className="botom_line" />
            </div>
          );
        })
      }
      {
        this.newPickupPoint.toCreate?
          this.renderNewPickupPoint() : ''
      }

      {
        this.newPickupPoint.toCreate?
          <div className="user_data center_div">
            <Row>
              <Col sm={12} className="right_content">
                <Button className="margin_left_right"
                  bsStyle="primary"
                  onClick={() => {
                    if(!Validation.pickupPointValidation(this.newPickupPoint, this.props.showMessage))
                      return false;
                    {
                      this.props.startSpinner();
                      this.newPickupPoint.teamId = this.selectedTeam.id;
                      this.newPickupPoint.companyId = this.props.company.id;
                      this.props.settingsActions.createPoint(this.newPickupPoint);
                      this.cancelNewPoint();
                    }
                  }}>
                    {gettext('CREATE')}
                </Button>
                <Button className="margin_left_right"
                  bsStyle="default"
                  onClick={() => this.cancelNewPoint()}>
                    {gettext('CANCEL')}
                </Button>
                <div className="botom_line" />
              </Col>
            </Row>
          </div>
          : ''
      }
      {
        !this.newPickupPoint.toCreate ?
          <div className="user_data center_div">
            <Row>
              <Col sm={12} className="right_content">
                <Button onClick={() => {this.newPickupPoint.toCreate = true; this.forceUpdate();}}>+</Button>
              </Col>
            </Row>
          </div>: ''
      }
      </div>
    );
  }

  renderNewPickupPoint() {
    this.newPickupPoint.toCreate = true;
    return (
        <div className="user_data center_div">
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>{gettext('TITLE')}</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                 type="text"
                 required={true}
                 onChange={(e) => this.newPickupPoint.title = e.target.value}
                 placeholder={gettext('TITLE')}/>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>{gettext('CONTACT-NAME')}</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                 type="text"
                 required={true}
                 onChange={(e) => this.newPickupPoint.contactName = e.target.value}
                 placeholder={gettext('CONTACT-NAME')}/>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>{gettext('PHONE')}</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                 type="text"
                 required={true}
                 onChange={(e) => this.newPickupPoint.phone = e.target.value}
                 placeholder={gettext('PHONE')}/>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>{gettext('ADDRESS')}</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <InputGroup>
                <Geosuggest
                  required={true}
                  name="defaultPickUpPoint"
                  placeholder={gettext('ADDRESS')}
                  inputClassName="_recipient_ _order_ form-control"
                  initialValue={this.newPickupPoint.address}
                  onSuggestSelect={(opts) =>
                    {
                      this.newPickupPoint.gpsLocation = opts.location;
                      this.newPickupPoint.address = opts.label;
                    }
                  }/>
                  <InputGroup.Addon onKeyDown={(e) => props.onKeyDown(e)}
                    onClick={() => this.showMapEdit()}>
                    { gettext('SELECT-ON-MAP') }
                  </InputGroup.Addon>
                </InputGroup>
            </Col>
          </Row>
        </div>
    );
  }

  deleteCallback() {
    this.resetBools();
    this.resetState();
  }


  render() {
    let filteredTeams = _.filter(this.props.teams, (team) => {
      return this.state.filterValue && team.name
              ? team.name.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) != -1
                  || this.props.getCityById(team.cityId).toUpperCase().indexOf(this.state.filterValue.toUpperCase()) != -1
              :true;
    });
    // const teams = _.map(filteredTeams, (team) => {
    //   const isTeamSelected = team === this.selectedTeam;
    //   const className = isTeamSelected ? 'active' : '';
    //   return (
    //     <Tr className={className} onClick={(e) => this.getSelectedTeam(team.id)}>
    //       <Td column={gettext('NAME')}>
    //         { team.name }
    //       </Td>
    //     </Tr>
    //   );
    // });

    const maps = this.isShowingMap ?
      (
        <MapModalComponent
          onMapClick={this.onMapClick}
          onClickOutsideOfMap={this.hideMapEdit}
          onCancel={this.hideMapEdit}
          hideMapEdit={this.hideMapEdit}
        />
      )
      : '';

    const mapForHub = this.isShowingHubMap ?
      (
        <MapModalComponent
          onMapClick={this.onHubMapClick}
          onClickOutsideOfMap={this.hideHubMap}
          onCancel={this.hideHubMap}
          hideMapEdit={this.hideHubMap}
        />
      )
      : '';

    const mapsForPolygon = this.isShowingPolygonMap ?
      (
        <MapModalComponent
          onMapClick={this.removePolygon}
          isDraw={true}
          polygon={this.state.polygon}
          onClickOutsideOfMap={this.hidePolygonMapEdit}
          onCancel={this.hidePolygonMapEdit}
          hideMapEdit={this.hidePolygonMapEdit}
          removePolygon={this.removePolygon}
          setPolygon={this.setPolygon}
        />
      )
      : '';
    
    return (
      <div>
        <Jumbotron className="company_profile">
          <div className="item_head_title">
            <h3>{gettext('TEAMS')}</h3>
          </div>
          <Row className="center_flex margin_bottom_em">
            <Col sm={10}>
              <Col sm={12}>
                <FormControl
                   type="text"
                   required={true}
                   placeholder={gettext('SEARCH')}
                   onChange={(e) => this.setState({filterValue: e.target.value})}/>
              </Col>
            </Col>
          </Row>
          <Row className="center_flex">
              <Col sm={10}>
                <Col sm={12}>
                  <div className="table_container">
                    <Table
                      width={300}
                      height={300}
                      headerHeight={20}
                      rowHeight={30}
                      rowClassName={({ index }) =>
                        this.selectedTeam
                        && filteredTeams[index] === this.selectedTeam? 'active' : ''
                      }
                      rowCount={filteredTeams.length}
                      rowGetter={({ index }) => filteredTeams[index]}
                      onRowClick={(e) => {
                        this.getSelectedTeam(e.rowData.id);
                      }}
                      >
                        <Column
                          label="Name"
                          dataKey="name"
                          width={500}
                        />
                    </Table>
                  </div>
                  <div className="milti_controls">
                   <Button className="multi_btn margin_bottom_halfem" onClick={() => {this.flipCreateTeam();}}>+</Button>
                   {
                     this.selectedTeam &&
                     <DeleteModal
                      delete={this.props.deleteTeam}
                      id={this.state.id}
                      text={`${gettext('DELETE-TEAM-CONFIRMATION')} ${this.selectedTeam.name}`}
                      callBack={this.deleteCallback}
                      buttonClass={'multi_btn margin_bottom_halfem'}
                      buttonText={'-'}/>
                   }
                  </div>
                </Col>
              </Col>
          </Row>
        </Jumbotron>
        {
          this.createTeam ? this.renderTeamCreateForm() : ''
        }
        {
          this.selectedTeam
            ? this.editTeam ? this.renderTeamEditForm():this.renderTeamForm()
            : ''
        }

        {maps}
        {mapsForPolygon}
        {mapForHub}
      </div>
    );
  }
}




TeamsComponent.propTypes = {

};

function mapStateToProps(state) {
  return {
    createdPickUpPoint: state.appReducer.createdPickUpPoint,
    teams: state.settingsPageReducer.teams,
    operators: state.settingsPageReducer.operators,
    dispatchers: state.settingsPageReducer.dispatchers,
    dispatcherPlatforms: state.settingsPageReducer.dispatcherPlatforms,
    drivers: state.settingsPageReducer.drivers,
    allOperators: state.settingsPageReducer.allOperators,
    allDispatchers: state.settingsPageReducer.allDispatchers,
    allDispatcherPlatforms: state.settingsPageReducer.allDispatcherPlatforms,
    allDrivers: state.settingsPageReducer.allDrivers,
    company: state.appReducer.company,
    pickUpPoints: state.settingsPageReducer.pickUpPoints,
    account: state.appReducer.account,
    addedToTeam: state.settingsPageReducer.addedToTeam,
    removedFromTeam: state.settingsPageReducer.removedFromTeam,
    teamDeleted: state.settingsPageReducer.teamDeleted,
    cities: state.settingsPageReducer.cities
  };
}

function mapDispatchToProps(dispatch) {
  return {
    settingsActions: bindActionCreators(settingsActions, dispatch),
    appActions:  bindActionCreators(appActions, dispatch),
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamsComponent);



// WEBPACK FOOTER //
// ./src/components/settings/components/TeamsComponent.js